<div class="dataset-provider-dashboard">
  <div class="dataset-provider-dashboard__header">
    <div class="dataset-provider-dashboard__header-main">
      <div class="dataset-provider-dashboard__icon">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 3v18h18"></path>
          <path d="M18 17V9"></path>
          <path d="M13 17V5"></path>
          <path d="M8 17v-3"></path>
        </svg>
      </div>
      <div class="dataset-provider-dashboard__header-text">
        <div class="dataset-provider-dashboard__eyebrow">
          <span class="dataset-provider-dashboard__badge">Analytics</span>
          <span class="dataset-provider-dashboard__live" *ngIf="!loading && !error">
            <span class="dataset-provider-dashboard__live-dot"></span>
            Live data
          </span>
        </div>
        <h3 class="dataset-provider-dashboard__title">Dataset Provider Dashboard</h3>
        <p class="dataset-provider-dashboard__subtitle">
          Your model evaluation submissions for {{ selectedDatasetTitle }}.
        </p>
      </div>
    </div>
  </div>

  <div class="dataset-provider-dashboard__body">
    <div class="dataset-provider-dashboard__filter">
      <label class="dataset-provider-dashboard__filter-label" for="dashboard-dataset-select">
        Benchmarking dataset
      </label>
      <select
        id="dashboard-dataset-select"
        class="dataset-provider-dashboard__select"
        [value]="selectedDatasetId"
        (change)="onDatasetChange($any($event.target).value)"
        [disabled]="loading || datasetOptions.length === 0"
      >
        <option
          *ngFor="let dataset of datasetOptions"
          [value]="dataset.id"
        >
          {{ dataset.title }}
        </option>
      </select>
    </div>

    <div *ngIf="loading" class="dashboard-state">
      <div class="dashboard-spinner"></div>
      <p>Loading submission analytics…</p>
    </div>

    <div *ngIf="!loading && error" class="dashboard-state dashboard-state--error">
      <div class="dashboard-state__icon">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
      </div>
      <p>{{ error }}</p>
      <button type="button" class="retry-btn" (click)="loadDashboard()">Try again</button>
    </div>

    <ng-container *ngIf="!loading && !error">
      <div class="kpi-grid">
        <div class="kpi-card kpi-card--views">
          <div class="kpi-card__glow"></div>
          <div class="kpi-card__icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z"/>
              <path d="m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65"/>
              <path d="m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65"/>
            </svg>
          </div>
          <div class="kpi-card__content">
            <span class="kpi-card__label">Models submitted</span>
            <span class="kpi-card__value">{{ formatCount(modelsSubmittedCount) }}</span>
          </div>
        </div>

        <div class="kpi-card kpi-card--access">
          <div class="kpi-card__glow"></div>
          <div class="kpi-card__icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
          </div>
          <div class="kpi-card__content">
            <span class="kpi-card__label">Successful model inferences</span>
            <span class="kpi-card__value">{{ formatCount(successfulModelInferencesCount) }}</span>
          </div>
        </div>

        <div class="kpi-card kpi-card--datasets">
          <div class="kpi-card__glow"></div>
          <div class="kpi-card__icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"></path>
              <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"></path>
              <path d="M4 22h16"></path>
              <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"></path>
            </svg>
          </div>
          <div class="kpi-card__content">
            <span class="kpi-card__label">Highest score</span>
            <span class="kpi-card__value">{{ highestScore !== null ? formatScore(highestScore) : '—' }}</span>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
